import styled from 'styled-components'
import { Button } from 'components'

export const StyledCancelButton = styled(Button)`
  border: 0;
  color: ${({ theme }) => theme.palette.grayscale[3]};
  text-decoration: none;
  
  > span {
    font-size: 0.8rem;
  }
  
  :hover, :focus {
    color: ${({ theme }) => theme.palette.grayscale[2]};
    text-decoration: none;
  }
`
